import PropTypes from "prop-types";
import classNames from "classnames";
import { useState, useEffect, useCallback, useMemo } from "react";
import BENEFITS from "./benefits.json";
import BENEFITS_BY_CATEGORY from "./benefits-by-category.json";
import {
  formCard,
  formLink,
  formSubmitButton,
  mAlignCenter,
  formButton,
} from "@/assets/styles/common.module.scss";
import {
  premiumStyle,
  headStyle,
  rupeeFontStyle,
  subHeadStyle,
  tncBottomLine,
  UinBottomLine,
  prodNameBottomLine,
  link,
  viewCoversLink,
  additionalInfoHeading,
  policyLinkDivider,
  policyLink
} from "./quote.module.scss";
import {
  getCustomerType,
  getMetadata,
} from "@/features/metadata/metadataSlice";
import { getCustomerTypeBolt } from "@/helpers/utils";
import {
  toAmount,
  isMobile,
  convertToLac,
  encrypt_AES_128_CBC,
} from "@/helpers/utils";
import ModalBox from "../core/ModalBox";
import HMuchMoreModal from "./modals/HMuchMoreModal";
import HPremiumBreakupModal from "./modals/HPremiumBreakupModal";
import {
  PRODUCT_NAME_UIN_MAP,
  SCHEME_TYPE,
  PRODUCT_NAME_LABEL_MAP,
  INTENT,
  MESSAGES,
  BOLT_QUOTE_REDIRECTION,
  PRODUCT_TYPE,
  PRODUCT_NAME_UIN_MAP_MEDICARE,
  PRODUCT_NAME_LABEL_MAP_MEDICARE,
  PRODUCT_CODE,
  MEDICARE_GENERIC_CODES,
  PACKAGES_COVERS_ENABLED_SUBPRODUCT_CODES,
  MEDICARE_SELECT_CODE,
  getCISLink,
  GRIEVANCE_REDRESSAL_LINK,
  MEDICARE_SELECT_REVISION_CODE,
  MEDICARE_SELECT_SUBPRODUCT_UIN_MAP,
} from "@/config/constants";
import UpgradePlanModal from "./modals/UpgradePlanModal";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { stickyButtonContainer } from "./quote.module.scss";
import {
  setUpSell,
  setBoltQuoteId,
  getBoltQuoteId,
  getUpSellDataSelector,
  getMigrationDetails,
  getSelectedCard,
  getOptedCovers,
  getCustomPlanDirty,
  getMigrationPlanDirty,
  getProductCode,
  getMobileNumber,
} from "@/features/quote/quoteSlice";
import { useDispatch, useSelector } from "react-redux";
import { IMAGE_BASE_PATH, BOLT_REDIRECTION, BOLT_SALT } from "@/config/config";
import Image from "next/image";
import axiosInstance from "@/middleware/axios-wrapper";
import { HTTP_STATUS_CODES } from "@/config/constants";
import ErrorMessageModal from "@/components/core/error-modals/ErrorMessage";
import { setProposalDetails } from "@/features/proposalDetails/proposalSlice";
import { EVENTS } from "@/config/events";
import { invokeMoengageAnalytics } from "@/utils/moengage";
import AddOnsCard from "./components/AddOnsCard";
import axios from "axios";
import { GLOBALUID_GENERATOR } from "@/config/config";
import AutoDebitModal from "./modals/AutoDebitModal";
import RedirectModal from "./modals/RedirectModal";
import { showLoader } from "@/features/loader/loaderSlice";

const HSubmitRenewalForm = ({
  renewalDetails,
  nextPageUrl,
  upsellData,
  producerUpsell,
  selectedPlanOption,
  onSelectedOptionChange,
  savedPlanPercentage,
  policyNumber,
  schemes,
  customerUpsell,
  offeredScheme,
  higherSIUpgrade,
  nextSlabSI,
  resource,
  sendLinkCustomer,
}) => {
  const router = useRouter();
  const { t } = useTranslation();

  const [benefits, setBenefits] = useState([]);
  const [mobileView, setMobileView] = useState(false);
  const [showBenefitsModal, setShowBenefitsModal] = useState(false);
  const [showPremiumBreakupModal, setShowPremiumBreakupModal] = useState(false);
  const [showUpgradePlanModal, setShowUpgradePlanModal] = useState(false);
  const existingBoltQuoteId = useSelector(getBoltQuoteId);
  const metaData = useSelector(getMetadata);
  const upsell = useSelector(getUpSellDataSelector);
  const productName = "Elder Care";
  const userType = useSelector(getCustomerType);
  const isCustomer = userType?.toLowerCase() === "customer";
  const producerRole = metaData?.producerRole;
  const isCustomerOrProducer =
    userType?.toLowerCase() === "customer" ||
    producerRole?.toLowerCase() === "producer";
  const customPlanDirty = useSelector(getCustomPlanDirty);
  const migrationPlanDirty = useSelector(getMigrationPlanDirty);
  const [globalUid, setGlobalUid] = useState(null);
  const [error, setError] = useState(null);
  const [hasGenerated, setHasGenerated] = useState(false);
  const [remarkMigrationPolicy, setRemarkMigrationPolicy] = useState(false);
  const propSelectedCard = useSelector(getSelectedCard);
  let isMedicareAddOn =
    MEDICARE_GENERIC_CODES.includes(renewalDetails?.productCode) &&
    renewalDetails?.isAddOnJourney;
  const [showRedirectModal, setShowRedirectModal] = useState(false);
  const utmMedium = metaData?.utm_medium;

  const productCodeFromStore = useSelector(getProductCode);
  const mobileNumberFromStore = useSelector(getMobileNumber);
  const invokeMoengageAnalyticsFunctionDefault = () => {
    invokeMoengageAnalytics(
      EVENTS.EVENT_RENEWAL_QUOTE_PAGE_DEFAULT_PLAN_SELECTION,
      {
        "Policy No": renewalDetails?.policyNo || "",
        "Product Name": renewalDetails?.productName || "",
        "Product Code": renewalDetails?.productCode?.toString() || productCodeFromStore?.toString() || "",
        "Mobile Number": mobileNumberFromStore || renewalDetails?.proposerDetails?.mobileNumber || "",
        DOB: renewalDetails?.proposerDetails?.dob || "",
        // "Scheme Type"  : selectedScheme || "",
        // Variant: renewalDetails?.variant || "",
        "Total Premium": renewalDetails?.asIsPremium || "",
        Tenure: renewalDetails?.tenure || "",
        "Sum Insured": renewalDetails?.memberDetails[0]?.applicableSI || "",
        "Producer Code": renewalDetails?.producerCode || "",
        is_app: utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
      }
    );
  };

  const invokeMoengageAnalyticsFunctionUpsell = () => {
    invokeMoengageAnalytics(
      EVENTS.EVENT_RENEWAL_QUOTE_PAGE_UPSELL_PLAN_SELECTION,
      {
        "Policy No": renewalDetails?.policyNo || "",
        "Product Name": renewalDetails?.productName || "",
        "Product Code": renewalDetails?.productCode?.toString() || productCodeFromStore?.toString() || "",
        "Mobile Number": mobileNumberFromStore || renewalDetails?.proposerDetails?.mobileNumber || "",
        DOB: renewalDetails?.proposerDetails?.dob || "",
        Variant: renewalDetails?.variant || "",
        "Scheme Type": offeredScheme?.schemeType || "",
        "Total Premium": offeredScheme?.totalPremium || "",
        Package: Object.values(offeredScheme?.packages || {}),
        Tenure: offeredScheme?.tenure || "",
        "Sum Insured": offeredScheme?.sumInsured || "",
        "Producer Code": renewalDetails?.producerCode || "",
        is_app: utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
      }
    );
  };

  const invokeMoengageAnalyticsFunctionPopUp = (
    premiumOfSuccess = "",
    sumInsuredOfSuccess = "",
    eventAddition = "",
    SelectionOption = ""
  ) => {
    const eventName = `EVENT_RENEWAL_QUOTE_PAGE_UPSELL_${eventAddition}`;
    invokeMoengageAnalytics(eventName, {
      "Policy No": renewalDetails?.policyNo || "",
      "Product Name": renewalDetails?.productName || "",
      "Product Code": renewalDetails?.productCode?.toString() || productCodeFromStore?.toString() || "",
      "Mobile Number": mobileNumberFromStore || renewalDetails?.proposerDetails?.mobileNumber || "",
      DOB: renewalDetails?.proposerDetails?.dob || "",
      // "Variant"      : renewalDetails?.variant || "",
      "Scheme Type": selectedCustomerScheme || "",
      "Total Premium": premiumOfSuccess || "",
      // "Package"      : packages[0]?.name || "",
      Tenure: renewalDetails?.tenure || 1,
      "Sum Insured": sumInsuredOfSuccess || "",
      "Producer Code": renewalDetails?.producerCode || "",
      Selection: SelectionOption || "",
      is_app: utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
    });
  };

 const handleGenerate = useCallback(async () => {
   try {
     const mobileNumber = mobileNumberFromStore || renewalDetails?.proposerDetails?.mobileNumber;

     if (!mobileNumber) {
       setError("Mobile number is missing.");
       return;
     }

     const response = await axios.post(
       GLOBALUID_GENERATOR,
       { mobile: mobileNumber },
       {
         headers: {
           "Content-Type": "application/json",
           Accept: "application/json",
         },
       }
     );

     const globalUid = response?.data?.data?.globalUid;

     if (window?.Moengage && globalUid) {
       window.Moengage.destroy_session();
       window.Moengage.add_unique_user_id(globalUid);
       window.Moengage.add_mobile(mobileNumber);
     }

     setGlobalUid(globalUid);
     setError(null);

     return true;
   } catch (err) {
     setError("Failed to generate Global UID.");
     return false;
   }
 }, [renewalDetails]);

 useEffect(() => {
   const initialize = async () => {
     if (
       t(PRODUCT_NAME_LABEL_MAP[renewalDetails?.productName]) ===
         "Criti-Medicare" &&
       isCustomer &&
       !hasGenerated
     ) {
       const success = await handleGenerate();

       if (success) {
         invokeMoengageAnalyticsFunctionDefault();
       }

       setHasGenerated(true);
     }
   };

   initialize();
 }, [isCustomer, hasGenerated, handleGenerate]);

  const handleOptionChange = useCallback(
    (event) => {
      const newSelectedOption = event.target.value;
      onSelectedOptionChange(newSelectedOption);
    },
    [onSelectedOptionChange]
  );

  const selectedScheme =
    resource === INTENT.GROUP_RENEW_QUOTE
      ? renewalDetails.premium.AsIs
      : renewalDetails.premiumSchemes.find((schema) => {
          return schemes
            ? schema.schemeType.replace(/\s/g, "").toLowerCase() ===
                schemes.replace(/\s/g, "").toLowerCase()
            : schema.schemeType.replace(/\s/g, "").toLowerCase() === "asis";
        });

  const num = (v) =>
    v === null || v === undefined || v === "" ? 0 : Number(v);

  const computeSchemeGST = (scheme) => {
    if (!scheme) return 0;
    const igst = num(scheme.igstVal ?? scheme.GST_VALUE);
    const sgst = num(scheme.sgstVal);
    const cgst = num(scheme.cgstVal);

    return Number.isFinite(igst) && igst > 0 ? igst : sgst + cgst;
  };

  const isGroup = resource === INTENT.GROUP_RENEW_QUOTE;

  const cutoff = new Date("2025-09-22T00:00:00.000Z");
  const sysDate = renewalDetails?.systemDate
    ? new Date(renewalDetails.systemDate)
    : new Date();
  const onOrAfterCutoff = !isNaN(sysDate) && sysDate >= cutoff;

  const gstComputedZero = computeSchemeGST(selectedScheme) === 0;
  const gstIsZero = isGroup ? false : gstComputedZero || onOrAfterCutoff;

  const [selectedCustomerPlan, setSelectedCustomerPlan] =
    useState(selectedScheme);

  const numberOfBenefitsLabel = t("view_benefits_statement").replace(
    "{{numberOfBenefits}}",
    benefits.length
  );
  const tataProductName = t("r_quote_bottomline_health_2").replace(
    "{{prdNm}}",
    t(PRODUCT_NAME_LABEL_MAP[renewalDetails?.productName])
  );
  const benefitsLabel = t("r_quote_muchMoreModal_header_health").replace(
    "{{prdNm}}",
    t("productName_criti_medicare")
  );
  const uinLabel = t("r_quote_bottomline_health_3").replace(
    "{{UIN}}",
    PRODUCT_NAME_UIN_MAP[renewalDetails?.productName] || ""
  );

  const uinLabelMedicare = t("r_quote_bottomline_health_3").replace(
    "{{UIN}}",
    // Medicare Select UIN depends on sub-product code, not the variant name.
    (MEDICARE_SELECT_CODE.includes(String(renewalDetails?.subProductCode))
      ? MEDICARE_SELECT_SUBPRODUCT_UIN_MAP[String(renewalDetails?.subProductCode)]
      : PRODUCT_NAME_UIN_MAP_MEDICARE[renewalDetails?.variant]) || ""
  );

  const tataProductNameMedicare = t("r_quote_bottomline_health_2").replace(
    "{{prdNm}}",
    t(PRODUCT_NAME_LABEL_MAP_MEDICARE[renewalDetails?.variant])
  );
  let tataProductMedicare = "";
  if (MEDICARE_GENERIC_CODES.includes(renewalDetails?.productCode)) {
    tataProductMedicare = t(
      PRODUCT_NAME_LABEL_MAP_MEDICARE[renewalDetails?.variant]
    );
  }

  const prodName = PRODUCT_NAME_LABEL_MAP[renewalDetails?.productName];

  const toggleBenefitsModal = () => setShowBenefitsModal(!showBenefitsModal);
  const toggleUpgradePlanModal = () => {
    const upgradePlanScheme =
      selectedCustomerScheme === selectedScheme.schemeType
        ? higherSIUpgrade
        : nextSlabSI;
    if (upgradePlanScheme) {
      setUpgradePlanScheme(upgradePlanScheme);
      const premiumDiffernece =
        selectedCustomerScheme === selectedScheme.schemeType
          ? toAmount(
              Math.round(
                upgradePlanScheme?.totalPremium - selectedScheme?.totalPremium
              )
            )
          : toAmount(
              Math.round(
                upgradePlanScheme?.totalPremium - offeredScheme?.totalPremium
              )
            );
      setUpgradePlanSI(
        upgradePlanScheme?.memberPremium?.m1?.policySchemeSumInsured
      );
      setUpgradePlanPrem(premiumDiffernece);
      setShowUpgradePlanModal(!showUpgradePlanModal);
    } else {
      upgradePlanModalAction(false);
    }
  };

  const [premiumDataToShow, setPremiumDataToShow] = useState(null);

  const dispatch = useDispatch();

  // Modify togglePremiumBreakupModal to accept dataToShow argument
  const togglePremiumBreakupModal = (dataToShow) => {
    if (resource === INTENT.GROUP_RENEW_QUOTE && dataToShow) {
      const gmcPremiumBreakup = {
        netPremium: dataToShow?.NET_PREMIUM,
        igstVal: dataToShow?.GST_VALUE,
        totalPremium: dataToShow?.TOTAL_PREMIUM,
      };
      setPremiumDataToShow(gmcPremiumBreakup);
    } else {
      setPremiumDataToShow(dataToShow);
    }
    setShowPremiumBreakupModal(!showPremiumBreakupModal);
  };

  // Open the modal with the selected scheme data
  const openSelectedSchemeModal = () => {
    togglePremiumBreakupModal(selectedScheme);
  };

  // Open the modal with the upsellData
  const openUpsellDataModal = () => {
    togglePremiumBreakupModal(upsellData);
  };

  // Open the modal with the offeredScheme
  const openOfferedSchemeModal = () => {
    togglePremiumBreakupModal(offeredScheme);
  };

  const onClickSubmit = (message) => {
    if (message === "Session expired, please login again to continue")
      router.push("/");
  };

  useEffect(() => {
    setMobileView(isMobile(window.innerWidth));
  }, []);

  useEffect(() => {
    // Update the Benefits Array as per the renewal details payload.
    const { sectionAflag, sectionBflag, sectionCflag, sectionDflag } =
      renewalDetails;
    const policyBenefits = [];
    if (sectionAflag) {
      policyBenefits.push(...BENEFITS_BY_CATEGORY["sectionA"]);
    }
    if (sectionBflag) {
      policyBenefits.push(...BENEFITS_BY_CATEGORY["sectionB"]);
    }
    if (sectionCflag) {
      policyBenefits.push(...BENEFITS_BY_CATEGORY["sectionC"]);
    }
    if (sectionDflag) {
      policyBenefits.push(...BENEFITS_BY_CATEGORY["sectionD"]);
    }
    setBenefits(policyBenefits);
  }, [renewalDetails]);

  const divider = (
    <div
      className="mt-2 mb-3 d-flex align-self-stretch"
      style={{ border: "1px dashed #bcbcbc" }}
    />
  );

  const displayPremiumStatemnt = (
    <div className={classNames(premiumStyle)}>
      {isMobile ? t("premium_titlecase") : t("total_premium_titlecase")}
    </div>
  );

  const displayPremiumAmount = (
    <div className={classNames("flexCenter", rupeeFontStyle)}>
      {/* <article>₹</article> */}
      <aside>
        ₹
        {toAmount(
          Math.round(
            selectedScheme?.totalPremium ?? selectedScheme?.TOTAL_PREMIUM
          )
        )}
        &nbsp;
      </aside>
    </div>
  );

  const displayGstStatement = (
    <div className={classNames(subHeadStyle, "mx-auto")}>
      <span className="d-one d-md-block">(</span>
      {t("inclusive_GST_statement")}
      <span className="d-none d-md-block">)</span>
    </div>
  );

  const displayPremiumInfo = (
    <div className="flexCenterColumn">
      {displayPremiumStatemnt}
      {displayPremiumAmount}
      {!gstIsZero && displayGstStatement}
    </div>
  );

  const quoteCardHeader = (
    <>
      <span className={classNames(headStyle)}>{t(prodName)}</span>
    </>
  );

  const showPremiumBreakup = (func) => {
    return (
      <a
        onClick={func}
        href="#"
        className="link-btn"
        // className={classNames(formLink, link)}
        id="renew-health-viewpremium"
      >
        {t("view_renewal_premium_breakup")}
      </a>
    );
  };

  const displayUpsellPremiumAmount = (
    <div className={classNames("flexCenter", rupeeFontStyle)}>
      {/* <article>₹</article> */}
      <aside>
        ₹{toAmount(Math.round(upsellData?.totalPremium))}
        {upsellData?.tenure > 1 && (
          <span>
            &nbsp;
            <Image
              src={`${IMAGE_BASE_PATH}/images/Separator-in-card.svg`}
              alt="X"
              width={10}
              height={28}
            />{" "}
            <span className="upsell-prem upsellPerPos">
              ₹
              {toAmount(
                Math.round(upsellData?.totalPremium / upsellData?.tenure)
              )}{" "}
              / <span className="upsell-value">Year</span>
            </span>
          </span>
        )}
      </aside>
    </div>
  );

  const displayOsPremiumAmount = (
    <div className={classNames("flexCenter", rupeeFontStyle)}>
      {/* <article>₹</article> */}
      <aside>
        ₹{toAmount(Math.round(offeredScheme?.totalPremium))}
        &nbsp;
      </aside>
    </div>
  );

  // Quote Api (bolt)
  const quoteBoltApi = async (
    schemeType = "",
    policyNo = "",
    premium = "",
    packages = [],
    bypassMandatoryPackages = false,
    isConsentByPassFlag = true,
    fromProductCode = null,
    toProductCode = null,
    roomCategory = "",
    opts = {},
    addonCovers = {},
    packagesOrCoversModified = false
  ) => {
    const requestBody = {
      policyNo,
      schemeType,
    };
    if (isMedicareAddOn) {
      Object.assign(requestBody, {
        premium: premium,
        packageList: packages,
        bypassMandatoryPackages: bypassMandatoryPackages,
        isConsentByPass: isConsentByPassFlag,
      });
    }
    if (fromProductCode && toProductCode) {
      requestBody.fromProductCode = fromProductCode;
      requestBody.toProductCode = toProductCode;
    }

    if (existingBoltQuoteId && upsell === schemeType)
      requestBody.quoteNo = existingBoltQuoteId;

    if (roomCategory) {
      requestBody.roomCategory = roomCategory;
    }

    if (opts?.uwRemark) {
      requestBody.remark = opts.uwRemark;
    }

    const isCoversEnabled = PACKAGES_COVERS_ENABLED_SUBPRODUCT_CODES.has(
      String(renewalDetails?.subProductCode || "")
    ) || PACKAGES_COVERS_ENABLED_SUBPRODUCT_CODES.has(
      String(toProductCode || "")
    ) || PACKAGES_COVERS_ENABLED_SUBPRODUCT_CODES.has(
      String(renewalDetails?.productCode || "")
    );

    const hasOptedAddonCovers =
      addonCovers &&
      typeof addonCovers === "object" &&
      Object.keys(addonCovers).length > 0;

    if (isCoversEnabled && hasOptedAddonCovers) {
      requestBody.addonCovers = addonCovers;
    }

    requestBody.packagesOrCoversModified = packagesOrCoversModified;

    try {
      const response = await axiosInstance.post(
        BOLT_QUOTE_REDIRECTION.RV_BOLT_QUOTE_API_URL,
        requestBody
      );

      if (
        response.statusCode === HTTP_STATUS_CODES.OK &&
        response?.data?.quoteNo
      ) {
        const quoteId = response?.data?.quoteNo;
        dispatch(setBoltQuoteId(quoteId));
        const redirectionObj = {
          quoteNo: quoteId,
          policyNo,
          userType: isSuperUser ? "super" : getCustomerTypeBolt(metaData),
          isKycByPass: renewalDetails?.isKycByPass || false,
          isConsentByPass: isMedicareAddOn
            ? isConsentByPassFlag
            : renewalDetails?.isConsentByPass || true,
          isRenewalPolicyEndorsed:
            renewalDetails?.isRenewalPolicyEndorsed || false,
          intent: BOLT_QUOTE_REDIRECTION.BOLT_INTENT, //RENEWAL
          action: BOLT_QUOTE_REDIRECTION.BOLT_ACTION, // edit
          userEmailID: metaData.producerEmailId || "",
          uwRemarks: opts?.uwRemark || "",
        };
        boltRedirection(redirectionObj);
      } else {
        if (isCustomer) {
          invokeMoengageAnalytics(EVENTS.EVENT_RENEWAL_ERROR, {
            Stage: "save-quote",
            "Error Description":
              error?.data?.message ||
              error?.message ||
              MESSAGES?.DEFAULT_MESSAGE ||
              "Error On Save Quote Page",
            "Product Code": renewalDetails?.productCode?.toString() ||  productCodeFromStore?.toString() || "",
            "is_app": utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
          });
        }
        throw new Error(MESSAGES.DEFAULT_MESSAGE);
      }
    } catch (error) {
      // console.log(error);
      if (isCustomer) {
        invokeMoengageAnalytics(EVENTS.EVENT_RENEWAL_ERROR, {
          Stage: "save-quote",
          "Error Description":
            error?.data?.message ||
            error?.message ||
            MESSAGES?.DEFAULT_MESSAGE ||
            "Error On Save Quote Page",
          "Product Code": renewalDetails?.productCode?.toString() || productCodeFromStore?.toString() || "",
          "is_app": utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
        });
      }
      setShowSuccessModal(false);
      setModalError(
        error?.data?.message || error?.message || "Oops something went wrong!"
      );
      toggleErrorMessage();
    }
  };

  const boltRedirection = (payload) => {
    dispatch(showLoader());
    const salt = BOLT_SALT;
    let token = encrypt_AES_128_CBC(salt, JSON.stringify(payload));
    if (token) {
      token = encodeURIComponent(token);
    }
    const source = BOLT_QUOTE_REDIRECTION?.BOLT_SOURCE;
    const url =
      BOLT_REDIRECTION +
      "/" +
      BOLT_QUOTE_REDIRECTION.URL +
      `token=${token}&source=${source}`;
    window.location.href = url;
  };

  const handleRenewalSubmit = () => {
    //TODO:

    // toggleUpgradePlanModal();
    if (producerUpsell) {
      dispatch(
        setUpSell(
          selectedPlanOption === "option1"
            ? selectedScheme.schemeType
            : upsellData.schemeType
        )
      );
    } else {
      dispatch(
        setUpSell(
          resource === INTENT.GROUP_RENEW_QUOTE
            ? "As Is"
            : selectedScheme.schemeType
        )
      );
    }

    if (renewalDetails?.productName === productName) {
      let schemeTypeUpdated;
      if (selectedPlanOption === "option1") {
        schemeTypeUpdated = selectedScheme?.schemeType;
      } else if (selectedPlanOption === "option2") {
        schemeTypeUpdated = upsellData?.schemeType;
      }

      // console.log(selectedPlanOption, policyNumber, selectedScheme, existingBoltQuoteId, schemeTypeUpdated, upsellData, renewalDetails);

      quoteBoltApi(schemeTypeUpdated, policyNumber);
      return;
    }

    dispatch(setProposalDetails({}));
    if (isCustomer) {
      invokeMoengageAnalytics(EVENTS.EVENT_RENEWAL_QUOTE_PAGE_RENEW_NOW, {
        Premium: selectedScheme.totalPremium?.toString() || "",
        // "Sum Insured":
        //   selectedScheme.memberPremium?.m1?.policySchemeSumInsured || "",
        "Policy Number": renewalDetails?.policyNo || "",
        Tenure: selectedScheme?.tenure || "",
        "Product Code": renewalDetails?.productCode?.toString() || productCodeFromStore?.toString() || "",
        "is_app": utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
      });
    }
    if (!isMedicareAddOn) {
      router.push(nextPageUrl);
    }
    // if (upSellPlan && selectedSchemeType.schemeType === SCHEME_TYPE.As_Is) {

    // } else {
    //   event.preventDefault();
    //   router.push(nextPageUrl);
    // }
  };

  const [errorMessageModal, setErrorMessageModal] = useState(false);
  const toggleErrorMessage = () => setErrorMessageModal((modal) => !modal);
  const [modalError, setModalError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [selectedCustomerScheme, setSelectedCustomerScheme] = useState(
    selectedScheme.schemeType
  );
  const [viewOffer, setViewOffer] = useState(false);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const toggleSuccessModal = () => {
    setShowSuccessModal(!showSuccessModal);
  };

  const sendLinkToCustomer = useCallback(async () => {
    try {
      const requestBody = {
        policyNo: policyNumber,
        schemeName:
          selectedPlanOption === "option1"
            ? selectedScheme?.schemeType
            : upsellData?.schemeType,
        businessType: "RETAIL",
        lob: "HEALTH",
        appName: "WEBSITE",
        roleName: "CUSTOMER",
        resource: "QUOTE",
      };
      const response = await axiosInstance.post(
        "/renewal/renewal-link/send",
        requestBody
      );

      if (response.statusCode === HTTP_STATUS_CODES.OK) {
        setSuccessMessage(response.message);
        setShowSuccessModal(true);
      } else {
        setShowSuccessModal(false);
        setModalError(response.message);
        toggleErrorMessage();
        // console.error("ERR");
      }
    } catch (error) {
      setModalError(error.data.message);
      toggleErrorMessage();
      setShowSuccessModal(false);
      // console.error(error);
    }
  }, [
    policyNumber,
    selectedPlanOption,
    selectedScheme?.schemeType,
    upsellData?.schemeType,
  ]);

  const handleCustomerCardClick = (selectedScheme) => {
    if (selectedScheme === offeredScheme?.schemeType && isCustomer) {
      invokeMoengageAnalyticsFunctionUpsell();
    } else {
      invokeMoengageAnalyticsFunctionDefault();
    }
    setSelectedCustomerScheme(selectedScheme);
  };

  const viewOfferClick = () => {
    setSelectedCustomerScheme(offeredScheme.schemeType);
    setViewOffer(true);
    if (offeredScheme && isCustomer) {
      invokeMoengageAnalytics(
        EVENTS.EVENT_RENEWAL_QUOTE_PAGE_UPSELL_PLAN_SELECTION,
        {
          "Select Plan": offeredScheme?.schemeType || "",
          "Total Premium": offeredScheme?.totalPremium || "",
          Tenure: offeredScheme?.tenure || "",
          "Sum Insured": renewalDetails?.memberDetails[0]?.applicableSI || "",
          "Producer Code": renewalDetails?.producerCode || "",
          "policy Number": renewalDetails?.policyNo || "",
          "Product Code": renewalDetails?.productCode?.toString() || productCodeFromStore?.toString() || "",
          "is_app": utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
        }
      );
    }
  };

  const [upgradePlanScheme, setUpgradePlanScheme] = useState(null);
  const [upgradePlanPrem, setUpgradePlanPrem] = useState(null);
  const [upgradePlanSI, setUpgradePlanSI] = useState(null);

  const upgradePlanModalAction = (action) => {
    setShowUpgradePlanModal(false);

    const schemeTypeToDispatch = action
      ? upgradePlanScheme.schemeType
      : selectedCustomerScheme === selectedScheme.schemeType
      ? selectedScheme.schemeType
      : offeredScheme.schemeType;

    dispatch(setUpSell(schemeTypeToDispatch));

    if (renewalDetails?.productName === productName) {
      if (isCustomer) {
        invokeMoengageAnalytics(EVENTS.EVENT_RENEWAL_QUOTE_PAGE_RENEW_NOW, {
          Premium:
            renewalDetails?.premiumSchemes?.find(
              (scheme) => scheme.schemeType === selectedCustomerScheme
            )?.totalPremium || "",
          "Scheme-Type": selectedCustomerScheme || "",
          "Policy Number": policyNumber || "",
          "Product Code": renewalDetails?.productCode?.toString() || "",
          "is_app": utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
        });
      }
      quoteBoltApi(selectedCustomerScheme, policyNumber);
      return;
    }

    dispatch(setProposalDetails({}));

    const schemeAnalyticsData = renewalDetails.premiumSchemes.find((schema) => {
      return (
        schema.schemeType.replace(/\s/g, "").toLowerCase() ===
        schemeTypeToDispatch.replace(/\s/g, "").toLowerCase()
      );
    });
    if (isCustomer) {
      invokeMoengageAnalytics(EVENTS.EVENT_RENEWAL_QUOTE_PAGE_RENEW_NOW, {
        Premium: schemeAnalyticsData?.totalPremium?.toString() || "",
        "Sum Insured":
          schemeAnalyticsData?.memberPremium?.m1?.policySchemeSumInsured || "",
        "Product Code": renewalDetails?.productCode?.toString() || productCodeFromStore?.toString() || "",
        "is_app": utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
      });
      if (!action) {
        invokeMoengageAnalyticsFunctionPopUp(
          schemeAnalyticsData?.totalPremium?.toString(),
          schemeAnalyticsData?.memberPremium?.m1?.policySchemeSumInsured,
          "POP_UP_FAIL",
          t("upgrade_plan_no_btn")
        );
      } else {
        invokeMoengageAnalyticsFunctionPopUp(
          schemeAnalyticsData?.totalPremium?.toString(),
          upgradePlanSI,
          "POP_UP_SUCCESS",
          t("upgrade_plan_yes_btn")
        );
      }
    }

    if (!isMedicareAddOn) {
      router.push(nextPageUrl);
    }
  };

  isMedicareAddOn =
    MEDICARE_GENERIC_CODES.includes(renewalDetails?.productCode) &&
    renewalDetails?.isAddOnJourney;
  const [addOnPremium, setAddOnPremium] = useState("");
  const [addOnScheme, setAddOnScheme] = useState("");
  const migrationDetails = useSelector(getMigrationDetails);
  const optedAddonCovers = useSelector(getOptedCovers);
  const [selectedPackagesArr, setSelectedPackagesArr] = useState([]);
  const [customerRecommendedPlan, setCustomerRecommendedPlan] = useState(null);
  const [customerUpsellFlag, setCustomerUpsellFlag] = useState(false);
  const isSuperUser = renewalDetails?.isGlobalSuperUser;

  const [showJustificationModal, setShowJustificationModal] = useState(false);
  const [pendingQuoteParams, setPendingQuoteParams] = useState(null);
  const [justificationText, setJustificationText] = useState("");

  const minJustificationChars = 10;
  const maxJustificationChars = 200;
  const justificationLen = justificationText?.length || 0;
  const justificationValid =
    justificationText.trim().length >= minJustificationChars;

  const openJustificationOrProceed = useCallback(
    (params) => {
      const asIsScheme = renewalDetails.premiumSchemes?.find(
        (schema) =>
          schema.schemeType?.replace(/\s/g, "").toLowerCase() === "asis"
      );

      const toNum = (v) =>
        v === undefined || v === null || v === "" ? null : Number(v);

      const asIsTenure = toNum(
        asIsScheme?.tenure ?? asIsScheme?.tenureSI?.tenure
      );
      const asIsSI = toNum(
        asIsScheme?.memberDetails?.[0]?.sumInsured ??
          asIsScheme?.tenureSI?.sumInsured ??
          asIsScheme?.sumInsured
      );

      const migTenure = toNum(
        migrationDetails?.migrationTenure ??
          migrationDetails?.migrationPremium?.tenureSI?.tenure
      );
      const migSI = toNum(
        migrationDetails?.migrationSI ??
          migrationDetails?.migrationPremium?.tenureSI?.sumInsured
      );

      const differs =
        (migTenure !== null &&
          asIsTenure !== null &&
          migTenure !== asIsTenure) ||
        (migSI !== null && asIsSI !== null && migSI !== asIsSI);

      const migrateCondition = isSuperUser === true;

      const asIsCondition =
        isSuperUser === true &&
        migrationDetails?.isMigrationPolicy === false &&
        migrationDetails?.isMigrationPolicySelected === true &&
        differs;

      const requiresJustification = migrateCondition;

      if (requiresJustification) {
        setPendingQuoteParams(params);
        setShowJustificationModal(true);
        return;
      }

      quoteBoltApi(
        params.schemeType,
        params.policyNo,
        params.premium,
        params.packages,
        params.bypassMandatoryPackages,
        params.isConsentByPassFlag,
        params.fromProductCode,
        params.toProductCode,
        params.roomCategory,
        params.extra?.uwRemark ? { uwRemark: params.extra.uwRemark } : {},
        params.addonCovers || {},
        params.packagesOrCoversModified
      );
    },
    [
      isSuperUser,
      renewalDetails?.premiumSchemes,
      migrationDetails?.isMigrationPolicy,
      migrationDetails?.isMigrationPolicySelected,
      migrationDetails?.migrationTenure,
      migrationDetails?.migrationSI,
      migrationDetails?.migrationPremium?.tenureSI?.tenure,
      migrationDetails?.migrationPremium?.tenureSI?.sumInsured,
    ]
  );

  const handleJustificationSubmit = useCallback(() => {
    if (!pendingQuoteParams || !justificationValid) return;

    if (!pendingQuoteParams.extra) pendingQuoteParams.extra = {};
    pendingQuoteParams.extra.changeJustification = justificationText;

    quoteBoltApi(
      pendingQuoteParams.schemeType,
      pendingQuoteParams.policyNo,
      pendingQuoteParams.premium,
      pendingQuoteParams.packages,
      pendingQuoteParams.bypassMandatoryPackages,
      pendingQuoteParams.isConsentByPassFlag,
      pendingQuoteParams.fromProductCode,
      pendingQuoteParams.toProductCode,
      pendingQuoteParams.roomCategory,
      { uwRemark: justificationText.trim() },
      pendingQuoteParams.addonCovers || {},
      pendingQuoteParams.packagesOrCoversModified
    );

    setShowJustificationModal(false);
    setJustificationText("");
    setPendingQuoteParams(null);
  }, [pendingQuoteParams, justificationText, justificationValid]);

  const proceedMedicareBoltRedirection = () => {
    const migrationScheme = migrationDetails.migrationPremium;
    const roomCategory = migrationDetails.migrationRoomCategory;
    const upsellFlag =
      userType?.toLowerCase() === "customer" &&
      customerUpsellFlag &&
      customerRecommendedPlan;

    if (upsellFlag && !customPlanDirty) {
      setUpgradePlanSI(customerRecommendedPlan.tenureSI.sumInsured);
      setUpgradePlanPrem(customerRecommendedPlan.totalPremium - addOnPremium);
      setShowUpgradePlanModal(!showUpgradePlanModal);
      return;
    }

    let effectiveSchemeObj;
    if (addOnScheme) {
      effectiveSchemeObj = renewalDetails.premiumSchemes.find(
        (s) => s.schemeType === addOnScheme
      );
    }
    const usingMigrationObject =
      migrationDetails?.isMigrationPolicySelected === true;

    const mig = usingMigrationObject ? migrationScheme : null;

    const effectiveSchemeType = usingMigrationObject
      ? mig?.schemeTypeName ?? "Migration"
      : addOnScheme;

    const effectivePremium = usingMigrationObject
      ? Number(mig?.totalPremium ?? 0)
      : Number(addOnPremium ?? 0);

    const effectivePackagesMap = usingMigrationObject
      ? mig?.packages ?? {}
      : renewalDetails.premiumSchemes.find((s) => s.schemeType === addOnScheme)
          ?.packages ?? {};

    const effectiveSelectedPackages = usingMigrationObject
      ? mig?.packageList ?? []
      : selectedPackagesArr ?? [];

    if (usingMigrationObject && !mig) {
      console.warn("Migration premium object missing – cannot proceed.");
      return;
    }

    let bypassMandatoryPackages = false;

    for (const key in effectivePackagesMap) {
      const pkg = effectivePackagesMap[key];
      if (pkg?.isMandatory && !effectiveSelectedPackages.includes(pkg.name)) {
        bypassMandatoryPackages = true;
        break;
      }
    }

    if (renewalDetails.isPackagesRemoved) {
      bypassMandatoryPackages = true;
    }

    dispatch(setUpSell(effectiveSchemeType));

    const isConsentByPassFlag =
      effectiveSchemeType?.replace(/\s/g, "").toLowerCase() === "asis";

    if (isCustomer) {
      invokeMoengageAnalytics(EVENTS.EVENT_RENEWAL_QUOTE_PAGE_RENEW_NOW, {
        Premium: effectivePremium || "",
        "Scheme-Type": effectiveSchemeType || "",
        "Policy Number": policyNumber || "",
        "Product Code": renewalDetails?.productCode?.toString() || productCodeFromStore?.toString() || "",
        "is_app": utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
      });
    }

    let fromProductCode = null;
    let toProductCode = null;
    if (usingMigrationObject || effectiveSchemeObj.isMigrationPolicySelected) {
      fromProductCode = migrationDetails.migrationFromProductCode;
      toProductCode = migrationDetails.migrationToProductCode;
    }

    const customRedirectFlag =
      propSelectedCard === "customisedPlan" && customPlanDirty;
    const migrationRedirectFlag =
      propSelectedCard === "migrationPlan" && migrationPlanDirty;

    const params = {
      schemeType: effectiveSchemeType,
      policyNo: policyNumber,
      premium: effectivePremium,
      packages: effectiveSelectedPackages,
      bypassMandatoryPackages,
      isConsentByPassFlag,
      fromProductCode,
      toProductCode,
      roomCategory,
      addonCovers: optedAddonCovers,
      packagesOrCoversModified: customRedirectFlag || migrationRedirectFlag,
      __usingMigrationObject: usingMigrationObject,
      extra: {},
    };

    openJustificationOrProceed(params);
  };

  const medicareBoltRedirection = useCallback(() => {
    const customRedirectFlag =
      propSelectedCard === "customisedPlan" && customPlanDirty;
    const migrationRedirectFlag =
      propSelectedCard === "migrationPlan" && migrationPlanDirty;
    if (isCustomerOrProducer && (customRedirectFlag || migrationRedirectFlag)) {
      setShowRedirectModal(true);
      return;
    }

    proceedMedicareBoltRedirection();
  }, [isCustomerOrProducer, proceedMedicareBoltRedirection]);

  const handleRedirectModalOkay = useCallback(() => {
    setShowRedirectModal(false);
    proceedMedicareBoltRedirection();
  }, [proceedMedicareBoltRedirection]);

  const customerUpgradeSchemeAction = (action) => {
    let schemeType = "";
    let schemePremium = "";
    if (action) {
      schemeType = customerRecommendedPlan.schemeTypeName;
      schemePremium = customerRecommendedPlan.totalPremium;
    } else {
      schemeType = addOnScheme;
      schemePremium = addOnPremium;
    }
    let bypassMandatoryPackages = false;
    const schemeObject = renewalDetails.premiumSchemes.find(
      (scheme) => scheme.schemeType === schemeType
    );

    if (!schemeObject) {
      console.log("Scheme object not found!");
      return;
    }
    const packages = schemeObject.packages;

    for (const key in packages) {
      if (
        packages[key].isMandatory &&
        !selectedPackagesArr.includes(packages[key].name)
      ) {
        bypassMandatoryPackages = true;
        break;
      }
    }

    if (renewalDetails.isPackagesRemoved) {
      bypassMandatoryPackages = true;
    }

    dispatch(setUpSell(schemeType));
    const isConsentByPassFlag =
      schemeType.replace(/\s/g, "").toLowerCase() === "asis" ? true : false;
    if (isCustomer) {
      invokeMoengageAnalytics(EVENTS.EVENT_RENEWAL_QUOTE_PAGE_RENEW_NOW, {
        Premium: schemePremium || "",
        "Scheme-Type": schemeType || "",
        "Sum Insured":
          (action
            ? upgradePlanSI
            : renewalDetails?.memberDetails[0]?.applicableSI) || "",
        "Policy Number": policyNumber || "",
        "Product Code": renewalDetails?.productCode?.toString() || productCodeFromStore?.toString() || "",
        "is_app": utmMedium?.toLowerCase()?.includes("mobile_app") ? "Yes" : "No",
      });
      if (!action) {
        invokeMoengageAnalyticsFunctionPopUp(
          schemePremium,
          renewalDetails?.memberDetails[0]?.applicableSI,
          "POP_UP_FAIL",
          t("upgrade_plan_no_btn")
        );
      } else {
        invokeMoengageAnalyticsFunctionPopUp(
          schemePremium,
          upgradePlanSI,
          "POP_UP_SUCCESS",
          t("upgrade_plan_yes_btn")
        );
      }
    }
    quoteBoltApi(
      schemeType,
      policyNumber,
      schemePremium,
      selectedPackagesArr,
      bypassMandatoryPackages,
      isConsentByPassFlag
    );
  };

  const [showModal, setShowModal] = useState(false);
  const toggleAutoDebitModal = useCallback(() => {
    setShowModal((prev) => !prev);
  }, []);

  useEffect(() => {
    if (renewalDetails?.autoDebitProcessing) {
      setShowModal(true);
    }
  }, [renewalDetails?.autoDebitProcessing]);

  const isMedicareSelectPolicy = MEDICARE_SELECT_CODE.includes(String(renewalDetails?.subProductCode));
  const isMedicareSelectRevision = MEDICARE_SELECT_REVISION_CODE === String(renewalDetails?.subProductCode);

  const shouldShowRenewNowButton = useMemo(() => {
    if (!isMedicareSelectPolicy || isCustomerOrProducer) return true;

    if (propSelectedCard === "migrationPlan") {
      return !migrationPlanDirty;
    }

    if (propSelectedCard === "customisedPlan") {
      return !customPlanDirty;
    }

    return true;
  }, [
    isMedicareSelectPolicy,
    propSelectedCard,
    customPlanDirty,
    migrationPlanDirty,
  ]);

  const additionalInfoBlock = () => {
    return (
      <>
        <div className={additionalInfoHeading}>Additional Information</div>
        <article className={classNames("detail-container mt-1 mb-2")}>
          <div>
            <div>
              <a
                href={getCISLink(renewalDetails)}
                target="_blank"
                rel="noopener noreferrer"
                className={policyLink}
              >
                Customer Information Sheet
              </a>
              <span className={policyLinkDivider}>&nbsp;|&nbsp;</span>
              <a
                href={GRIEVANCE_REDRESSAL_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className={policyLink}
              >
                Grievance Redressal
              </a>
            </div>
          </div>
        </article>
      </>
    );
  };

  return (
    <>
      {isMedicareAddOn ? (
        <>
          <AddOnsCard
            premiumSchemes={renewalDetails.premiumSchemes}
            variant={renewalDetails.variant}
            productName={renewalDetails?.productName || ""}
            productCode={String(renewalDetails?.productCode || "")}
            setAddOnPremium={setAddOnPremium}
            // tataProductNameMedicare={tataProductNameMedicare}
            // uinLabelMedicare={uinLabelMedicare}
            setAddOnScheme={setAddOnScheme}
            setSelectedPackagesArr={setSelectedPackagesArr}
            addonCovers={renewalDetails.addonCovers}
            setShowPremiumBreakupModal={setShowPremiumBreakupModal}
            setPremiumDataToShow={setPremiumDataToShow}
            setCustomerRecommendedPlan={setCustomerRecommendedPlan}
            setCustomerUpsellFlag={setCustomerUpsellFlag}
            isMobile={mobileView}
            setRemarkMigrationPolicy={setRemarkMigrationPolicy}
            medicareBoltRedirection={proceedMedicareBoltRedirection}
          />
          <aside
            className={classNames(
              "container-fluid d-none d-md-block fixed-bottom",
              stickyButtonContainer
            )}
          >
            <section
              className={classNames(
                "container d-flex py-2",
                selectedPackagesArr.length > 0 || isMedicareSelectRevision
                  ? "justify-content-between"
                  : "justify-content-end"
              )}
            >
              <ul className="package-info-list">
                {isMedicareSelectRevision && (
                  <li className="package-info">
                    Note: Global cover discount will be applicable if member’s
                    nationality and residential status is declared.
                  </li>
                )}
                {selectedPackagesArr.length > 0 && (
                  <>
                    <li className="package-info">
                      * Each package consists of selected add-on covers and
                      additional benefits tailored to your policy.
                    </li>
                    <li className="package-info">
                      {" "}
                      * Insured members applicability to packages and covers
                      will be governed by the product rules.
                    </li>
                  </>
                )}
              </ul>

              {/* <div className="package-info">
                
              </div>
              <div className="package-info">

              </div> */}
              <button
                type="button"
                className={classNames(
                  "btn rounded-pill m-0 upsell-renew-btn",
                  formSubmitButton
                )}
                onClick={medicareBoltRedirection}
                id="renew-health-renew-now"
                disabled={renewalDetails.autoDebitProcessing}
              >
                {t("r_quote_renew_now_cta")}
                {shouldShowRenewNowButton && (
                  <>
                    {" "}
                    at <span>₹ </span>
                    <span>
                      {toAmount(
                        Math.round(
                          addOnPremium ||
                            migrationDetails.migrationPremium.totalPremium
                        )
                      )}
                    </span>
                  </>
                )}
              </button>
            </section>
          </aside>
          <button
            type="button"
            className={classNames(
              "btn col-12 d-md-none fixed-bottom",
              formSubmitButton
            )}
            onClick={medicareBoltRedirection}
            disabled={renewalDetails.autoDebitProcessing}
          >
            {t("r_quote_renew_now_cta")} at <span>₹ </span>
            <span>
              {toAmount(
                Math.round(
                  addOnPremium || migrationDetails.migrationPremium.totalPremium
                )
              )}
            </span>
          </button>
        </>
      ) : customerUpsell ? (
        <>
          {divider}
          <div className="upsellPolicyContainer">
            <div className="row">
              <div className="col-xl-4 plan-border-right">
                <div className="row px-3">
                  <div className="col-md-12 quote-card-plan">
                    <span>Your Current Plan</span>
                  </div>
                  <div
                    className={`col-md-12 mt-3 ${
                      selectedCustomerScheme === selectedScheme.schemeType
                        ? "quote-pressed-card"
                        : "quote-select-card"
                    } ${selectedScheme.tenure === 1 ? "one-year-card" : ""}`}
                    onClick={() =>
                      handleCustomerCardClick(selectedScheme.schemeType)
                    }
                  >
                    <div className="card-header">
                      {MEDICARE_GENERIC_CODES.includes(
                        renewalDetails?.productCode
                      ) ? (
                        <span> {tataProductMedicare}</span>
                      ) : (
                        <span>{t(prodName)}</span>
                      )}
                      <span className="card-header-tenure">
                        {selectedScheme.tenure} Year
                      </span>
                    </div>
                    {divider}
                    <div className="premium-section">
                      <span className="premium-value">
                        <div className="px-1">
                          <label
                            className={classNames("p-0 mb-1", premiumStyle)}
                          >
                            {t("as_low_as")}
                          </label>
                        </div>
                        {displayPremiumAmount}
                      </span>
                      <div>
                        <article
                          className={classNames("detail-container mt-2")}
                        >
                          {showPremiumBreakup(openSelectedSchemeModal)}
                        </article>
                      </div>
                    </div>
                    {selectedScheme.tenure === 2 ||
                    selectedScheme.tenure === 3 ? (
                      <div className="card-footer different-msg">
                        <span className="footer-info">
                          Save{" "}
                          {selectedScheme.tenure === 2 ? (
                            <span className="p-0">5%</span>
                          ) : (
                            <span className="p-0">10%</span>
                          )}
                        </span>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-xl-4 upsellSchemeCard">
                <div className="row px-3">
                  <div className="col-md-12 quote-card-plan">
                    <span>
                      You Are Eligible for Tenure Discount Offer on Premium
                    </span>
                  </div>
                  {!viewOffer ? (
                    <div className="col-md-12 mt-3 view-offer-box">
                      <div className="row">
                        <div className="col-md-12 flexCenter mt-3">
                          <Image
                            src={`${IMAGE_BASE_PATH}/images/Gift-box-illustration.svg`}
                            alt="X"
                            width={100}
                            height={100}
                          />
                        </div>
                        <div className="col-md-12 flexCenter">
                          <button
                            type="button"
                            className={classNames(
                              "btn rounded-pill m-0",
                              formButton
                            )}
                            onClick={viewOfferClick}
                          >
                            Get Offer
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`col-md-12 mt-3 flip-card ${
                        selectedCustomerScheme === offeredScheme.schemeType
                          ? "quote-pressed-card"
                          : "quote-select-card"
                      }`}
                      onClick={() =>
                        handleCustomerCardClick(offeredScheme.schemeType)
                      }
                    >
                      <div className="card-header">
                        {MEDICARE_GENERIC_CODES.includes(
                          renewalDetails?.productCode
                        ) ? (
                          <span> {tataProductMedicare}</span>
                        ) : (
                          <span>{t(prodName)}</span>
                        )}
                        {/* <span>{t(prodName)}</span> */}
                        <span className="card-header-tenure">
                          {offeredScheme.tenure} Years
                        </span>
                      </div>
                      {divider}
                      <div className="premium-section">
                        <span className="premium-value">
                          <div className="px-1">
                            <label
                              className={classNames("p-0 mb-1", premiumStyle)}
                            >
                              {t("as_low_as")}
                            </label>
                          </div>
                          {displayOsPremiumAmount}
                        </span>
                        <div>
                          <article
                            className={classNames("detail-container mt-2")}
                          >
                            {showPremiumBreakup(openOfferedSchemeModal)}
                          </article>
                        </div>
                      </div>
                      <div className="card-footer different-msg">
                        <span className="footer-info">
                          Save{" "}
                          {offeredScheme.tenure === 2 ? (
                            <span className="p-0">5%</span>
                          ) : (
                            <span className="p-0">10%</span>
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <article
                className={classNames("detail-container mt-2", mAlignCenter)}
              >
                <div>
                  <div className={classNames(UinBottomLine)}>
                    <span className={classNames(prodNameBottomLine)}>
                      {MEDICARE_GENERIC_CODES.includes(
                        renewalDetails?.productCode
                      )
                        ? tataProductNameMedicare
                        : tataProductName}
                    </span>
                    <span>&nbsp;|&nbsp;</span>
                    {MEDICARE_GENERIC_CODES.includes(
                      renewalDetails?.productCode
                    ) ? (
                      <span> {uinLabelMedicare}</span>
                    ) : (
                      <span> {uinLabel}</span>
                    )}
                  </div>
                </div>
              </article>
              {additionalInfoBlock()}
            </div>
          </div>
          <aside
            className={classNames(
              "container-fluid d-none d-md-block fixed-bottom",
              stickyButtonContainer
            )}
          >
            <section className="container d-flex justify-content-end py-2">
              <button
                type="button"
                className={classNames(
                  "btn rounded-pill m-0 upsell-renew-btn",
                  formSubmitButton
                )}
                onClick={toggleUpgradePlanModal}
                id="renew-health-renew-now"
                disabled={renewalDetails.autoDebitProcessing}
              >
                {t("r_quote_renew_now_cta")} at <span>₹ </span>
                <span>
                  {selectedCustomerScheme === selectedScheme.schemeType
                    ? toAmount(Math.round(selectedScheme?.totalPremium))
                    : selectedCustomerScheme === offeredScheme.schemeType
                    ? toAmount(Math.round(offeredScheme?.totalPremium))
                    : null}
                </span>
              </button>
            </section>
          </aside>
          <button
            type="button"
            className={classNames(
              "btn col-12 d-md-none fixed-bottom",
              formSubmitButton
            )}
            onClick={toggleUpgradePlanModal}
            disabled={renewalDetails.autoDebitProcessing}
          >
            {t("r_quote_renew_now_cta")} at <span>₹ </span>
            <span>
              {selectedCustomerScheme === selectedScheme.schemeType
                ? toAmount(Math.round(selectedScheme?.totalPremium))
                : selectedCustomerScheme === offeredScheme.schemeType
                ? toAmount(Math.round(offeredScheme?.totalPremium))
                : null}
            </span>
          </button>
        </>
      ) : producerUpsell ? (
        <>
          {" "}
          <div className="row mt-4">
            <div className="tata-card-container col-md-6 col-lg-4">
              <input
                type="radio"
                id="current"
                name="CurrentPlan"
                value="option1"
                checked={selectedPlanOption == "option1"}
                onChange={handleOptionChange}
              />
              <label className="tata-card" htmlFor="current">
                <div className="tata-card-header">
                  <div className="header-title">{t("current_plan")}</div>
                </div>
                <div className="tata-card-body">
                  <div className="info-section">
                    <label className="theme-value">
                      {t("tenure")}
                      <span className="theme-label">
                        {selectedScheme.tenure}{" "}
                        {selectedScheme.tenure == 1 ? <>Year</> : <>Year(s)</>}
                      </span>
                    </label>
                    <label className="theme-value">
                      {t("sum_insured_titlecase")}
                      <span className="theme-label">
                        ₹{" "}
                        {convertToLac(
                          selectedScheme.memberPremium?.m1
                            ?.policySchemeSumInsured
                        )}
                        &nbsp;Lakhs
                      </span>
                    </label>
                  </div>
                  <div className="premium-section same-card-height">
                    <span className="premium-value">
                      <div className="px-1">
                        <label className={classNames("p-0 mb-1", premiumStyle)}>
                          {t("as_low_as")}
                        </label>
                      </div>
                      {displayPremiumAmount}
                    </span>
                    <article
                      className={classNames(
                        "detail-container mt-2",
                        mAlignCenter
                      )}
                    >
                      <div>
                        <article
                          className={classNames("detail-container mt-2")}
                        >
                          {showPremiumBreakup(openSelectedSchemeModal)}
                        </article>
                      </div>
                    </article>
                  </div>
                </div>
              </label>
            </div>

            {upsellData ? (
              <>
                <div className="tata-card-container col-md-6 col-lg-4">
                  <input
                    type="radio"
                    id="custom"
                    name="CustomPlan"
                    value="option2"
                    checked={selectedPlanOption == "option2"}
                    onChange={handleOptionChange}
                  />
                  <label className="tata-card" htmlFor="custom">
                    <div className="tata-card-header">
                      <div className="header-title">{t("custom_plan")}</div>
                    </div>
                    <div className="tata-card-body">
                      <div className="info-section">
                        <label className="theme-value">
                          {t("tenure")}
                          <span className="theme-label">
                            {upsellData?.tenure} Year(s)
                          </span>
                        </label>
                        <label className="theme-value">
                          {t("sum_insured_titlecase")}
                          <span className="theme-label">
                            ₹{" "}
                            {convertToLac(
                              upsellData?.memberPremium?.m1
                                ?.policySchemeSumInsured
                            )}
                            &nbsp;Lakhs
                          </span>
                        </label>
                      </div>
                      <div className="premium-section">
                        <span className="premium-value">
                          <div className="px-1">
                            <label
                              className={classNames("p-0 mb-1", premiumStyle)}
                            >
                              {t("as_low_as")}
                            </label>
                          </div>
                          {displayUpsellPremiumAmount}
                        </span>
                        <article
                          className={classNames(
                            "detail-container mt-2",
                            mAlignCenter
                          )}
                        >
                          <div>
                            <article
                              className={classNames("detail-container mt-2")}
                            >
                              {showPremiumBreakup(openUpsellDataModal)}
                            </article>
                          </div>
                        </article>
                      </div>
                    </div>
                    <div className="tata-card-footer different-msg">
                      <span className="footer-info">
                        {savedPlanPercentage ? (
                          <>Save {savedPlanPercentage}%</>
                        ) : (
                          <>Save</>
                        )}
                        {upsellData?.memberPremium?.m1?.policySchemeSumInsured >
                          selectedScheme.memberPremium?.m1
                            ?.policySchemeSumInsured && (
                          <>
                            {savedPlanPercentage && <> & </>}
                            Additional ₹{" "}
                            {convertToLac(
                              upsellData?.memberPremium?.m1
                                .policySchemeSumInsured -
                                selectedScheme.memberPremium.m1
                                  .policySchemeSumInsured
                            )}
                            L Coverage
                          </>
                        )}
                      </span>
                    </div>
                  </label>
                </div>
              </>
            ) : null}
            <div
              className="row"
              style={{ paddingBottom: "80px", overflowY: "auto" }}
            >
              <article
                className={classNames("detail-container mt-2", mAlignCenter)}
              >
                <div>
                  <div className={classNames(UinBottomLine)}>
                    <span className={classNames(prodNameBottomLine)}>
                      {MEDICARE_GENERIC_CODES.includes(
                        renewalDetails?.productCode
                      )
                        ? tataProductNameMedicare
                        : tataProductName}
                    </span>
                    <span>&nbsp;|&nbsp;</span>
                    {MEDICARE_GENERIC_CODES.includes(
                      renewalDetails?.productCode
                    ) ? (
                      <span> {uinLabelMedicare}</span>
                    ) : (
                      <span> {uinLabel}</span>
                    )}
                  </div>
                </div>
              </article>
              {additionalInfoBlock()}
            </div>
          </div>
          <aside
            className={classNames(
              "container-fluid d-none d-md-block fixed-bottom",
              stickyButtonContainer
            )}
          >
            <section className="container d-flex justify-content-end py-2">
              {sendLinkCustomer && (
                <button
                  type="button"
                  className={classNames("btn rounded-pill", formButton)}
                  onClick={sendLinkToCustomer}
                  id="renew-health-renew-now"
                >
                  {`${t("send_link_btn")}`}
                </button>
              )}
              <button
                type="button"
                className={classNames(
                  "btn rounded-pill m-0 upsell-renew-btn",
                  formSubmitButton
                )}
                onClick={handleRenewalSubmit}
                id="renew-health-renew-now"
                disabled={renewalDetails.autoDebitProcessing}
              >
                {t("r_quote_renew_now_cta")} at <span>₹ </span>
                <span>
                  {selectedPlanOption === "option1"
                    ? toAmount(Math.round(selectedScheme?.totalPremium))
                    : selectedPlanOption === "option2"
                    ? toAmount(Math.round(upsellData?.totalPremium))
                    : null}
                </span>
              </button>
            </section>
          </aside>
          <button
            type="button"
            className={classNames(
              "btn col-12 d-md-none fixed-bottom",
              formSubmitButton
            )}
            onClick={handleRenewalSubmit}
            disabled={renewalDetails.autoDebitProcessing}
          >
            {t("r_quote_renew_now_cta")} at <span>₹ </span>
            <span>
              {selectedPlanOption === "option1"
                ? toAmount(Math.round(selectedScheme?.totalPremium))
                : selectedPlanOption === "option2"
                ? toAmount(Math.round(upsellData?.totalPremium))
                : null}
            </span>
          </button>
        </>
      ) : (
        <>
          <form className={classNames(formCard, "rFontSize")}>
            <div className="rQuoteCard mAlignCenter">
              {MEDICARE_GENERIC_CODES.includes(renewalDetails?.productCode) ? (
                <span className={classNames(headStyle)}>
                  {" "}
                  {tataProductMedicare}
                </span>
              ) : (
                quoteCardHeader
              )}
              {!mobileView && divider}

              <div className=" text-center d-flex flex-column align-items-center ">
                {displayPremiumInfo}
                {mobileView && divider}

                {/* 
            //TODO: Benefits flow is commented temporarily. Additional information awaited
            {benefits.length > 0 && (
              <div>
                <a
                  href="#"
                  onClick={toggleBenefitsModal}
                  className={classNames(formLink, link, viewCoversLink)}
                  id="renew-health-muchmore"
                >
                  {numberOfBenefitsLabel}
                </a>
                <span className={classNames(link)}> *</span>
              </div>
            )} */}

                <button
                  type="button"
                  className={classNames(
                    "btn rounded-pill col-md-10 col-sm-12 my-3",
                    formSubmitButton
                  )}
                  onClick={() => {
                    handleRenewalSubmit();
                  }}
                  id="renew-health-renew-now"
                  disabled={renewalDetails.autoDebitProcessing}
                >
                  {t("r_quote_renew_now_cta")}
                </button>
              </div>
            </div>
          </form>

          <article
            className={classNames("detail-container mt-2", mAlignCenter)}
          >
            <div>
              <article className={classNames("detail-container mt-2")}>
                {showPremiumBreakup(openSelectedSchemeModal)}
              </article>
              <div className={classNames(UinBottomLine)}>
                <span className={classNames(prodNameBottomLine)}>
                  {MEDICARE_GENERIC_CODES.includes(renewalDetails?.productCode)
                    ? tataProductNameMedicare
                    : tataProductName}
                  {/* {tataProductName} */}
                </span>
                <span>&nbsp;|&nbsp;</span>
                {MEDICARE_GENERIC_CODES.includes(
                  renewalDetails?.productCode
                ) ? (
                  <span> {uinLabelMedicare}</span>
                ) : (
                  <span> {uinLabel}</span>
                )}
                {/* <span> {uinLabel}</span> */}
              </div>
              {additionalInfoBlock()}
            </div>
          </article>

          {/* <ModalBox
            show={showPremiumBreakupModal}
            toggle={togglePremiumBreakupModal}
            headerTxt={t("r_quote_hpremiumbreakup_health_header")}
            size="md"
            className="rPremiumBreakupModal"
            onModalDismiss={() => {}}
          >
            <HPremiumBreakupModal premiumDetails={selectedScheme} />
          </ModalBox> */}
          {/* 
      //TODO: Benefits flow is commented temporarily. Additional information awaited.
      <ModalBox
        show={showBenefitsModal}
        toggle={toggleBenefitsModal}
        headerTxt={benefitsLabel}
        size="md"
        className="rPremiumBreakupModal"
        isFullWidth={mobileView}
        onModalDismiss={() => {}}
      >
        <HMuchMoreModal benefitsArray={benefits} />
      </ModalBox> */}
          {/* <ModalBox
        showHeader={false}
        show={showUpgradePlanModal}
        toggle={toggleUpgradePlanModal}
        size="md"
        isFullWidth={mobileView}
      >
        <UpgradePlanModal
          nextPageUrl={nextPageUrl}
          toggleUpgradePlanModal={toggleUpgradePlanModal}
          upSellPlan={upSellPlan}
          originalPremium={totalPremium}
          selectedSchemeType={selectedSchemeType}
        />
      </ModalBox> */}
        </>
      )}
      <ModalBox
        show={showPremiumBreakupModal}
        toggle={togglePremiumBreakupModal}
        headerTxt={t("r_quote_hpremiumbreakup_health_header")}
        size="md"
        className="rPremiumBreakupModal"
        onModalDismiss={() => {}}
      >
        {premiumDataToShow && (
          <HPremiumBreakupModal
            premiumDetails={premiumDataToShow}
            systemDate={renewalDetails?.systemDate || new Date().toISOString()}
            isGroup={resource === INTENT.GROUP_RENEW_QUOTE}
          />
        )}
      </ModalBox>
      <ModalBox
        show={showSuccessModal}
        toggle={toggleSuccessModal}
        headerTxt={"Success"}
        size="md"
        className="rPremiumBreakupModal"
        onModalDismiss={() => {}}
      >
        <div className="row mAlignCenter">
          <div className="col-md-12 text-center">
            <div className="boldContentClass5">{successMessage}</div>
          </div>
        </div>
      </ModalBox>
      <ErrorMessageModal
        show={errorMessageModal}
        toggle={toggleErrorMessage}
        message={modalError}
        onClickSubmit={() => onClickSubmit(modalError)}
      />
      <ModalBox
        show={showUpgradePlanModal}
        toggle={toggleUpgradePlanModal}
        headerTxt={"Upgrade Plan"}
        size="md"
        className="rPremiumBreakupModal"
        onModalDismiss={() => {}}
      >
        <div
          className="row mAlignCenter upgrade-plan-bg px-3"
          style={{
            backgroundImage: `url(${IMAGE_BASE_PATH}/images/health_d_thankyouPage_family_success.png)`,
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="col-md-12 ">
            <div className="row">
              <div className="col-md-6 upgrade-plan-disclaimer mt-4">
                <span>Did You Know :</span> Hospitalization costs are on the
                rise! Which is why we recommend that you upgrade your coverage
                amount
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="boldContentClass5">
              Would You Like To Increase Your Sum Insured To ₹{" "}
              <span className="font-bold">
                {toAmount(Math.round(upgradePlanSI))}{" "}
              </span>
              For Just ₹{" "}
              <span className="font-bold">{toAmount(upgradePlanPrem)}</span>{" "}
              More?
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6">
            <button
              type="button"
              className={classNames("btn rounded-pill w-100", formButton)}
              onClick={() => {
                if (isMedicareAddOn) {
                  customerUpgradeSchemeAction(false);
                } else {
                  upgradePlanModalAction(false);
                }
              }}
            >
              {t("upgrade_plan_no_btn")}
            </button>
          </div>
          <div className="col-md-6">
            <button
              type="button"
              className={classNames(
                "btn rounded-pill w-100 m-0",
                formSubmitButton
              )}
              onClick={() => {
                if (isMedicareAddOn) {
                  customerUpgradeSchemeAction(true);
                } else {
                  upgradePlanModalAction(true);
                }
              }}
            >
              {t("upgrade_plan_yes_btn")}
            </button>
          </div>
        </div>
      </ModalBox>
      <AutoDebitModal
        show={showModal}
        onClose={toggleAutoDebitModal}
        title="Auto-debit Initiated"
        message="Auto debit is initiated for your policy. Please wait for policy issuance."
        confirmText="Ok"
      />
      <ModalBox
        show={showJustificationModal}
        toggle={() => {
          setShowJustificationModal(false);
          setJustificationText("");
          setPendingQuoteParams(null);
        }}
        headerTxt={"State the reason for this change"}
        size="md"
        className="rPremiumBreakupModal"
        onModalDismiss={() => {}}
      >
        <div className="row">
          <div className="col-12">
            <label htmlFor="change-justification" className="form-label">
              Please provide your justification (10–200 characters)
            </label>
            <textarea
              id="change-justification"
              className="form-control"
              value={justificationText}
              onChange={(e) => {
                const v = e.target.value.slice(0, maxJustificationChars);
                setJustificationText(v);
              }}
              rows={4}
              maxLength={maxJustificationChars}
              placeholder="Type your reason…"
            />
            <div className="d-flex justify-content-between mt-2">
              <small
                className={justificationValid ? "text-muted" : "text-danger"}
              >
                {justificationValid
                  ? "Looks good."
                  : `Enter at least ${minJustificationChars} characters.`}
              </small>
              <small className="text-muted">
                {justificationLen}/{maxJustificationChars}
              </small>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-6">
              <button
                type="button"
                className={classNames("btn rounded-pill w-100", formButton)}
                onClick={() => {
                  setShowJustificationModal(false);
                  setJustificationText("");
                  setPendingQuoteParams(null);
                }}
              >
                Cancel
              </button>
            </div>
            <div className="col-md-6">
              <button
                type="button"
                className={classNames(
                  "btn rounded-pill w-100 m-0",
                  formSubmitButton
                )}
                onClick={handleJustificationSubmit}
                disabled={
                  !justificationValid || renewalDetails.autoDebitProcessing
                }
                title={
                  !justificationValid ? "Enter at least 10 characters" : ""
                }
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </ModalBox>
      <RedirectModal
        show={showRedirectModal}
        onConfirm={handleRedirectModalOkay}
      />
    </>
  );
};

HSubmitRenewalForm.propTypes = {
  nextPageUrl: PropTypes.string,
  renewalDetails: PropTypes.shape({
    premiumSchemes: PropTypes.array,
    productName: PropTypes.string,
    sectionAflag: PropTypes.bool,
    sectionBflag: PropTypes.bool,
    sectionCflag: PropTypes.bool,
    sectionDflag: PropTypes.bool,
    totalPremium: PropTypes.string,
    premium: PropTypes.object,
    productCode: PropTypes.number,
    variant: PropTypes.string,
    isKycByPass: PropTypes.bool,
    isConsentByPass: PropTypes.bool,
    isRenewalPolicyEndorsed: PropTypes.bool,
    memberDetails: PropTypes.array,
    producerCode: PropTypes.string,
    isAddOnJourney: PropTypes.bool,
    addonCovers: PropTypes.object,
    isPackagesRemoved: PropTypes.bool,
    proposerDetails: PropTypes.any,
    asIsPremium: PropTypes.object,
    tenure: PropTypes.object,
    policyNo: PropTypes.object,
    autoDebitProcessing: PropTypes.bool,
    systemDate: PropTypes.string,
    productMigrationData: PropTypes.object,
    isGlobalSuperUser: PropTypes.bool,
    subProductCode: PropTypes.string,
  }),
  upsellData: PropTypes.any,
  producerUpsell: PropTypes.bool,
  selectedPlanOption: PropTypes.string,
  onSelectedOptionChange: PropTypes.func,
  savedPlanPercentage: PropTypes.number,
  policyNumber: PropTypes.string,
  schemes: PropTypes.string,
  customerUpsell: PropTypes.bool,
  offeredScheme: PropTypes.object,
  higherSIUpgrade: PropTypes.object,
  nextSlabSI: PropTypes.object,
  resource: PropTypes.string,
  sendLinkCustomer: PropTypes.bool,
};

export default HSubmitRenewalForm;
